// @flow
import React from "react";

import {
    Switch,
    Route,
    Redirect,
    withRouter,
    type Match,
    type RouterHistory,
} from "react-router";

import List from "./List";

type Props = {
    match: Match,
    history: RouterHistory,
};

import stripslash from "../../../../utils/stripslash";

const Issues = ({ match, history }: Props) => (
    <Switch>
        <Route path={`${match.path}`} exact>
            <Redirect to={`${stripslash(match.url)}/page/1/`} />
        </Route>
        <Route path={`${match.path}page/:page/`}>
            <List
                onPageChange={page =>
                    history.push(`${stripslash(match.url)}/page/${page}/`)
                }
            />
        </Route>
    </Switch>
);

export default withRouter<any>(Issues);
